// extracted by mini-css-extract-plugin
module.exports = {"root":"HeaderSearchInput_root___NF8H","icon":"HeaderSearchInput_icon__JOg6n"};